import { Row, Input, Col, Space, Divider } from "antd";
function FieldVier(props) {
  return (
    <Col span={props.span}>
      <Col>{props.field}</Col>
      <Col>
        <Input
          style={{ borderWidth: 3, color: "black" }}
          value={props.value ?? ""}
          disabled
        />
      </Col>
    </Col>
  );
}

const eventLabels = {
  Send: "Enviado",
  Delivery: "Entregue",
  Bounce: "E-mail não pôde ser entregue",
  Complaint: "Marcou como Spam/Denunciou",
  Click: "Clicou em Link no E-mail",
  Open: "Abriu E-mail",
  Reject: "SES rejeitou envio",
  RenderingFailure: "Erro de Renderização",
};

function formatToBrasilia(utcDateStr) {
  const date = new Date(utcDateStr);

  const options = {
    timeZone: "America/Sao_Paulo",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  const formatted = new Intl.DateTimeFormat("pt-BR", options).format(date);

  return formatted.replace(",", " às");
}

function ModalEvent(props) {
  return (
    <Col>
      <Col>
        <p>Informações sobre o evento</p>
      </Col>

      <Row justify={"space-evenly"} style={{ paddingTop: "1%" }}>
        <FieldVier
          span={3}
          field={"Evento"}
          value={props != {} ? props.data.detail.id : ""}
        />
        <FieldVier
          span={3}
          field={"Tipo de Evento"}
          value={
            props != {}
              ? props.data.detail.event_type === "Open"
                ? "Abriu E-mail"
                : props.data.detail.event_type === "Delivery"
                ? "Entregue"
                : props.data.detail.event_type === "Send"
                ? "Enviado"
                : props.data.detail.event_type === "Click"
                ? "Clicou em link no E-mail"
                : props.data.detail.event_type === "Bounce"
                ? "E-mail não pôde ser entregue"
                : props.data.detail.event_type === "Rendering Failure"
                ? "Erro de Renderização"
                : props.data.detail.event_type === "Complaint"
                ? "Marcou como Spam/Denunciou"
                : props.data.detail.event_type === "Reject"
                ? "SES rejeitou envio"
                : props.data.detail.event_type === "DeliveryDelay"
                ? "Entregue com atraso"
                : ""
              : ""
          }
        />

        <FieldVier
          span={3}
          field={"Enviado Por"}
          value={props != {} ? props.data.detail.sender_address : ""}
        />
        <FieldVier
          span={3}
          field={"E-mail enviado em"}
          value={
            props != {}
              ? formatToBrasilia(props.data.detail.mail_timestamp)
              : ""
          }
        />
        <FieldVier
          span={3}
          field={"id conta e-mail enviou"}
          value={props != {} ? props.data.detail.mail_sending_account_id : ""}
        />
        <FieldVier
          span={3}
          field={"Domínio SES por"}
          value={props != {} ? props.data.detail.ses_from_domain : ""}
        />
      </Row>
      <Row justify={"space-evenly"} style={{ paddingTop: "1%", margin: "3px" }}>
        <FieldVier
          span={3}
          field={"Id Destinatário"}
          value={props != {} ? props.data.detail.EmailCustomer.id : ""}
        />
        <FieldVier
          span={3}
          field={"Assunto"}
          value={props != {} ? props.data.detail.mail_subject : ""}
        />
        <FieldVier
          span={3}
          field={"Data do Evento"}
          value={
            props != {}
              ? formatToBrasilia(props.data.detail.event_timestamp)
              : ""
          }
        />
        <FieldVier
          span={3}
          field={"ses config set"}
          value={props != {} ? props.data.detail.ses_config_set : ""}
        />
        <FieldVier
          span={3}
          field={"E-mail Destinatário"}
          value={props != {} ? props.data.detail.EmailCustomer.address : ""}
        />

        <FieldVier
          span={3}
          field={"Ativo"}
          value={
            props != {}
              ? props.data.detail.EmailCustomer.active
                ? "Sim"
                : "Não"
              : ""
          }
        />
      </Row>

      <Row justify={"space-evenly"} style={{ paddingTop: "1%" }}>
        <Divider />
        {props.data.detail.event_type == "Bounce" ? (
          <>
            <FieldVier
              span={6}
              field={"Tipo de Bounce"}
              value={props != {} ? props.data.detail.bounce_type : ""}
            />
            <FieldVier
              span={6}
              field={"SubTipo de Bounce"}
              value={props != {} ? props.data.detail.bounce_subtype : ""}
            />
            <FieldVier
              span={6}
              field={"Código diagnóstico do Bounce"}
              value={
                props != {} ? props.data.detail.bounce_diagnostic_code : ""
              }
            />
          </>
        ) : null}
        {props.data.detail.event_type == "Click" ? (
          <>
            {" "}
            <FieldVier
              span={6}
              field={"Link clicado no e-mail:"}
              value={props != {} ? props.data.detail.click_link : ""}
            />
            <FieldVier
              span={6}
              field={"Operador utilizado"}
              value={props != {} ? props.data.detail.click_user_agent : ""}
            />
          </>
        ) : null}
        {props.data.detail.event_type == "Complaint" ? (
          <>
            {" "}
            <FieldVier
              span={6}
              field={"Feedback da Reclamação"}
              value={
                props != {} ? props.data.detail.complaint_feedback_type : ""
              }
            />
            <FieldVier
              span={6}
              field={"Operador utilizado"}
              value={props != {} ? props.data.detail.complaint_user_agent : ""}
            />
          </>
        ) : null}
      </Row>
    </Col>
  );
}

export default ModalEvent;
